var React = require('react');

function Gift (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M274.58,25.61l56.99,97.5c7.74,13.24,20.67,22.64,35.65,25.91l110.34,24.07c21.29,4.64,29.68,30.49,15.19,46.76l-75.12,84.33c-10.2,11.45-15.14,26.66-13.62,41.92l11.2,112.38c2.16,21.68-19.83,37.65-39.78,28.9l-103.42-45.38c-14.04-6.16-30.03-6.16-44.07,0l-103.41,45.38c-19.95,8.76-41.94-7.22-39.78-28.9l11.2-112.38c1.52-15.26-3.42-30.47-13.62-41.92L7.23,219.85c-14.48-16.27-6.09-42.11,15.2-46.76l110.34-24.07c14.98-3.27,27.91-12.67,35.65-25.91l56.99-97.5c10.99-18.81,38.17-18.81,49.16,0"}));
}

Gift.defaultProps = {"id":"Layer_1","viewBox":"0 0 500 500"};

module.exports = Gift;

Gift.default = Gift;
